module.exports = __webpack_public_path__ + "img/Elo.6e0d022b.svg";